import Request from './RequestHandler.js'

export default {
  upload (formData) {
    return Request.upload('uploads/image', formData)
  }
}
